<template lang="pug">
.product-item
  .product-data-container(@click="expand = !expand")
    .product-data
      .product-image-preview(v-if="!history" @click.stop="openImagePreview")
        img(v-if="productImageSrc" :src="productImageSrc" :alt="data.product" @click.stop="openImagePreview")

      .product-number
        span.material-symbols-outlined(:class="`color-${data.brand}`") inventory_2
        span.tag.uppercase(:class="`bg-${data.brand}`") {{ data.product }}

      .product-article.capitalize(v-if="!history") {{ data.article }}

      .product-price(v-if="!history") {{ money(data.priceUnit) }}

      .product-available(v-if="!history") Total: {{ data.totalAvailable }}

      template(v-if="!history && data.totalAvailable")
        .product-size(v-for="(size, i) in data.sizes" :key="size" :style="`order:${sizeOrder[size]}`") {{ size.toUpperCase() }}: {{ data.quantityAvailable[i] }}

      .product-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    transition(name="slide-fade")
      shForm.list-product(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

    transition(name="slide-fade")
      shHistory.list-product(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")

  shImagePreviewModal(
    :show="showImagePreview"
    :src="productImageSrc"
    :alt="data.product"
    @close="showImagePreview = false"
  )
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shImagePreviewModal from '@/components/elements/ImagePreviewModal'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Product',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory, shImagePreviewModal },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      showImagePreview: false,
      sizeOrder: {
        'xxs': 1, 'xs': 2, 's': 3, 'm': 4, 'l': 5, 'xl': 6, 'xxl': 7,
        '0': 8, '1': 9, '2': 10, '3': 11, '4': 12, '5': 13, '6': 14,
        '7': 15, '8': 16, '9': 17, '10': 18, '11': 19, '12': 20, '13': 21,
        '14': 22, '15': 23, '16': 24, '17': 25, '18': 26, '19': 27, '20': 28,
        '21': 29, '22': 30, '23': 31, '24': 32, '25': 33, '26': 34, '27': 35,
        '28': 36, '29': 37, '30': 38, '31': 39, '32': 40, '33': 41, '34': 42,
        '35': 43, '36': 44, '37': 45, '38': 46, '39': 47, '40': 48, '41': 49, '42': 50
      }
    }
  },

  computed: {
    productImageSrc () {
      if (!this.data.images || !this.data.images[0]) return ''
      return `${this.imagePath}/${this.data.brand}/${this.data.folder}/${this.data.subfolder}/${this.data.images[0]}`
    }
  },

  methods: {
    openImagePreview (event) {
      if (event) event.stopPropagation()
      if (this.productImageSrc) this.showImagePreview = true
    }
  },

  beforeDestroy () {
    this.expand = false
    this.showImagePreview = false
  }
}
</script>

<style lang="stylus">
.product-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.product-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.product-image-preview
  height 8em
  width 8em
  flex-shrink 0
  border-radius .4em
  background rgba(0, 0, 0, .05)
  margin-right 1em
  cursor pointer

.product-image-preview img
  height 100%
  width 100%
  display block
  object-fit cover
  border-radius .4em

.product-number
  display flex
  align-items center
  gap .5em

.product-size
  display flex
  align-items center

.list-product
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .product-data
    column-gap 0
    row-gap 1em

  .product-number
    width 10em
  .product-article
    width 10em
  .product-price
    width 8em
  .product-available
    width 8em
  .product-size
    width 5em
  .product-transaction
    width 8em
</style>



// WEBPACK FOOTER //
// src/components/pages/product/Product.vue